import has from 'lodash-es/has'

import {
  getCleanDateParam,
  getDateEndParam,
  getDateStartParam,
} from '../../../utils/filter'
import { FilterValueTags } from '../FilterValueTags'

import { getTag } from './FilterValue.utils'

function FilterValue({
  disabled,
  entity,
  filter,
  filterOptions,
  relatedFilters,
  onClear,
  onClick,
  onSetDateRange,
}) {
  const { name, type } = filter

  const tag = getTag(filter, filterOptions, relatedFilters, onSetDateRange)

  function handleClick(value) {
    onClick(name, value, type)
  }

  function handleClear() {
    if (tag) {
      const cleanParam = getCleanDateParam(name)

      const startKeyName = getDateStartParam(cleanParam)

      const endKeyName = getDateEndParam(cleanParam)

      onSetDateRange(startKeyName, null, endKeyName, null, type)
    } else {
      onClear(name)
    }
  }

  if (!filterOptions) {
    return null
  }

  const hasFilter = has(filterOptions, name)

  if (!hasFilter && !tag) {
    return null
  }

  return (
    <FilterValueTags
      disabled={disabled}
      entity={entity}
      filterOption={filterOptions[name] || [tag]}
      name={name}
      tag={tag}
      onClear={handleClear}
      onClick={handleClick}
    />
  )
}

export default FilterValue
